import $ from 'jquery';

import { problemModalState } from './modals/problemModalStore';

import { AlertOptions, ProblemContext, PartialProblemContext } from './index';

const DEFAULT_THEME_COLOR = '#5bc0de';
const DEFAULT_CONTRASTING_THEME_COLOR = 'rgb(227, 0, 123)';

export function makeProblemContext(
  partialProblemContext: PartialProblemContext
): ProblemContext {
  let timeSeenStart: Date;

  const alert = (dialog: AlertOptions): void => {
    problemModalState().alert(dialog);
  };

  const defaultProblemContext: ProblemContext = {
    config: partialProblemContext.config,
    getThemeName: () => 'green',
    getThemeColor: () => DEFAULT_THEME_COLOR,
    getContrastingThemeColor: () => DEFAULT_CONTRASTING_THEME_COLOR,
    setLoading: (_loadingState: boolean) => {},
    isPermitReadAloud: () => false,
    isStudent: () => false,
    activity: () => true,
    getSS: () => undefined,
    getUsername: () => undefined,
    setCurrentUncertain: () => {},
    getGuid: () => undefined,
    getProblems: () => {},
    isTesting: () => false,
    isUseNativeKeyboard: () => false,
    isForceTouchKeyboard: () => false,
    errorToServer: (message: string) => {
      const username = partialProblemContext?.getUsername?.() || 'unknown';
      const messageObject = {
        m: 'errorFromNonStudent, username ' + username + ': ' + message,
      };

      $.ajax({
        type: 'POST',
        dataType: 'json',
        url: partialProblemContext.config.JAVA_URL + '/ErrorToServer',
        data: messageObject,
        error: function (jqXHR) {
          console.error(
            'Error during errorToServer:',
            jqXHR.status,
            jqXHR.statusText,
            jqXHR.responseText
          );
        },
      });
    },

    attemptSubmitted: data => {
      if (data.probGenerationFail) {
        alert({
          msg: `GMM cannot create this type of problem! Please tell a friendly GMM person that ${data.probFailType} is broken.`,
          style: 'red',
          top: 'Technical Difficulty',
        });

        return;
      }

      const messages = data.m;

      if (messages) {
        for (const x3 in messages) {
          if (typeof x3 === 'string') {
            alert({
              msg: messages[x3],
              top: 'Message',
            });
          }
        }
      }
    },
    harvestTimeSeen: () => {
      if (!timeSeenStart) {
        timeSeenStart = new Date();

        return 0;
      }

      const delta = new Date().getTime() - timeSeenStart.getTime();

      timeSeenStart = new Date();

      return delta;
    },
    processAjaxFailure: () => false,
    addStackableDialog: (dialog: AlertOptions) => {
      alert(dialog);
    },
    getCurrentSkillId: () => undefined,
  };

  return { ...defaultProblemContext, ...partialProblemContext };
}
